import EventsService from '../services/Events.service';
import { observable, action } from 'mobx';

class EventsStore {
  events = observable([]);
  initialFetchDone = observable.box(false);

  @action
  async getEvents() {
    if (this.initialFetchDone.get()) {
      return this.events;
    }

    try {
      const items = await EventsService.fetchEvents();

      if (items.isEmpty) {
        return [];
      }

      this.events.push(...items.items);
      this.initialFetchDone.set(true);
    } catch (e) {
      console.error('Failed to fetch events data');
      return null;
    }

    return this.events;
  }
}

export default new EventsStore();



// WEBPACK FOOTER //
// ./src/stores/Events.store.js